import { Dropdown, Field, FixedOptionTextOutput, NumericInput, TextOutput } from 'Components/Core';
import { IFieldProps } from 'Components/Core/Field/types';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetBatchUpdateImportSourceField } from 'Components/WorksheetBatchUpdate/Core';
import { WorksheetBatchUpdateWorksheetFieldSection } from 'Components/WorksheetBatchUpdate/types';
import { FdReportResultsOption } from 'Components/Worksheets/SandReplacementWorksheet/types';
import React from 'react';
import { WorksheetBatchUpdateWorksheetField } from '../..';

export const BsSandReplacementWorksheetSections: {
  [name: string]: WorksheetBatchUpdateWorksheetFieldSection;
} = {
  laboratoryDensity: {
    heading: 'Laboratory Density',
  },
  results: {
    heading: 'Results',
  },
};

export const BsSandReplacementWorksheetFields: {
  [name: string]: WorksheetBatchUpdateWorksheetField;
} = {
  'data.Preparation.MeasurementApplication': {
    displayComponent: <Field input={<FixedOptionTextOutput />} />,
  },
  'data.IsParticleDensityAssumed': {
    displayComponent: <Field input={<FixedOptionTextOutput />} />,
    entryComponent: <Field input={<Dropdown />} simpleValue isClearable={false} />,
    defaultValue: true,
    displayFieldsWhenEntered: [
      'data.Preparation.MeasurementApplication',
      'data.ParticleDensityAssumed',
      'data.ReferenceDensityResults.ParticleDensity',
      'data.Results.AirVoids',
    ],
    section: 'laboratoryDensity',
  },
  'data.ParticleDensityAssumed': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    displayFieldsWhenEntered: [
      'data.Preparation.MeasurementApplication',
      'data.IsParticleDensityAssumed',
      'data.Results.AirVoids',
    ],
    section: 'laboratoryDensity',
  },
  'data.ReferenceDensity.ImportedTest': {
    /**
     * Special display component - extract meaningful string from imported test model
     */
    displayComponent: React.createElement(
      withInjectedProps<IFieldProps>(({ value, ...otherFieldProps }) => (
        <Field
          {...otherFieldProps}
          input={<TextOutput />}
          value={value?.Results?.ReferenceId ?? value?.Sample?.SampleId}
        />
      ))
    ),
    entryComponent: <WorksheetBatchUpdateImportSourceField importPropertyName={'ReferenceDensity'} />,
    alsoSets: ['data.ReferenceDensity.AssociatedTestType'],
    displayFieldsWhenEntered: [
      'data.Preparation.MeasurementApplication',
      'data.ReferenceDensityResults.ParticleDensity',
      'data.Results.MaximumDryDensity',
      'data.Results.OptimumMoistureContent',
      'data.Results.RelativeCompaction',
      'data.Results.AirVoids',
    ],
    isImportSource: true,
    section: 'laboratoryDensity',
  },
  'data.ReferenceDensityResults.ParticleDensity': {
    displayComponent: <Field input={<TextOutput />} />,
    section: 'laboratoryDensity',
  },
  'data.Results.MaximumDryDensity': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.OptimumMoistureContent': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.RelativeCompaction': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.AirVoids': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Results.ReportResultsOption': {
    displayComponent: <Field input={<FixedOptionTextOutput />} />,
    entryComponent: <Field input={<Dropdown />} simpleValue isClearable={false} />,
    defaultValue: FdReportResultsOption.RelativeCompactionOnly,
    displayFieldsWhenEntered: [
      'data.Preparation.MeasurementApplication',
      'data.Results.RelativeCompaction',
      'data.Results.AirVoids',
    ],
    section: 'results',
  },
};

export default BsSandReplacementWorksheetFields;
